import { Skeleton } from "components/ui/skeleton";

export function PlanCardSkeleton() {
  return (
    <div className="relative flex flex-col rounded-2xl border border-line dark:border-white/[0.10] bg-surface dark:bg-dark-700/60 overflow-hidden">
   
      <Skeleton variant="block" className="!h-[3px] !rounded-none w-full shrink-0" />

      <div className="p-5 flex flex-col gap-4 flex-1">
        <div className="flex items-center gap-3">
          <Skeleton variant="block" className="!w-10 !h-10 !rounded-xl shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" className="!w-24 !h-3.5" />
            <Skeleton variant="text" className="!w-36 !h-2.5" />
          </div>
        </div>
        <div className="space-y-1.5">
          <Skeleton variant="text" className="!w-28 !h-8" />
          <Skeleton variant="text" className="!w-20 !h-2.5" />
          <Skeleton variant="text" className="!w-44 !h-2.5" />
        </div>

        <div className="space-y-1.5">
          <Skeleton variant="text" className="!w-full !h-2.5" />
          <Skeleton variant="text" className="!w-4/5 !h-2.5" />
        </div>

        <div className="space-y-2.5">
          {([80, 95, 70, 85, 60] as const).map((pct, i) => (
            <div key={i} className="flex items-center gap-2">
              <Skeleton variant="block" className="!w-4 !h-4 !rounded-full shrink-0" />
              <Skeleton variant="text" className="!h-2.5" style={{ width: `${pct}%` }} />
            </div>
          ))}
        </div>

        <Skeleton variant="block" className="!h-10 !rounded-xl w-full mt-auto" />
      </div>
    </div>
  );
}

export function PlanCardGridSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <PlanCardSkeleton key={i} />
      ))}
    </div>
  );
}
